import React, { FC } from 'react';
import styles from './LoadingView.module.scss';
import { LoadingViewStrings } from '../../../utils/strings';
import { Heading } from '../../shared/Heading';
import { Texts } from '../../shared/Texts';

interface LoadingViewProps {
  isSummary?: boolean;
}

export const LoadingView: FC<LoadingViewProps> = ({ isSummary }) => {
  return (
    <section id="loader" className={styles.loading} role="alert">
      <div className={styles.img_wrapper} aria-disabled="true">
        <img src="/motylek.png" alt="" />
      </div>
      <Heading type="h1" className={styles.loader_header}>
        {LoadingViewStrings.h1}
      </Heading>
      <Texts className={styles.loader_desc}>
        {isSummary ? LoadingViewStrings.p1 : LoadingViewStrings.p1Pretest}
      </Texts>
    </section>
  );
};
